import { render, staticRenderFns } from "./item-request-logs.vue?vue&type=template&id=b65d2a36&"
import script from "./item-request-logs.vue?vue&type=script&lang=js&"
export * from "./item-request-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports